import { Dataflow01 } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

export default {
  name: "application",
  priority: 5,
  icon: Dataflow01,
  menu: ({ t }: { t: TFunction }) => ({
    admin: [
      {
        label: t("Workflow", { ns: "application.admin" }),
        icon: <Dataflow01 />,
        child: [
          {
            label: t("Processes", { ns: "application.shared" }),
            to: "/admin/application/applications",
            permission: "application.application.view",
          },
          {
            label: t("Categories", { ns: "core.shared" }),
            to: "/admin/application/categories",
            permission: "application.application-category.view",
          },
        ],
      },
    ],
  }),
} satisfies ModuleData;
